import React, { FC, ReactNode } from 'react';
import cx from 'classnames';

import styles from './Steps.scss';

export type StepItem = {
  height?: number;
  imgAvif?: string;
  imgPng: string;
  imgWebp?: string;
  text: ReactNode;
  time: string;
  width?: number;
};

type StepsProps = {
  className?: string;
  config: StepItem[];
};

export const Steps: FC<StepsProps> = ({ className, config }) => (
  <div className={cx(styles.steps, className)}>
    {config.map((item) => {
      const {
        height,
        imgAvif,
        imgPng,
        imgWebp,
        text,
        time,
        width,
      } = item;

      return (
        <div key={time} className={styles.stepsCard}>
          <picture>
            {imgAvif && <source srcSet={imgAvif} type="image/avif" />}
            {imgWebp && <source srcSet={imgWebp} type="image/webp" />}
            <img
              alt={time}
              loading="lazy"
              src={imgPng}
              {...{ height, width }}
            />
          </picture>
          <h3>{time}</h3>
          <p>{text}</p>
        </div>
      );
    })}
  </div>
);
